import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import {
  PersonalInformationResponse,
  ToggleOnboardingStatusResponse,
} from '@app/utils/interfaces/onboardingSlide.interface';

@Injectable({
  providedIn: 'root',
})
export class StaffService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly http = inject(HttpClient);

  public getPersonalInformation(): Observable<PersonalInformationResponse> {
    return this.http.get<PersonalInformationResponse>(
      `${this.baseUrl}${ApiEndpoints.GET_PERSONAL_INFORMATION}`,
    );
  }

  public toggleOnboardingStatus(isCompleted: boolean): Observable<ToggleOnboardingStatusResponse> {
    return this.http.patch<ToggleOnboardingStatusResponse>(
      `${this.baseUrl}${ApiEndpoints.TOGGLE_ONBOARDING_STATUS}=${isCompleted}`,
      {},
    );
  }
}
